import * as yup from 'yup'
import { REQUIRED_MESSAGE } from '../constants'

export const AutocompleteValueSchemaObject = {
  text: yup.string().required(REQUIRED_MESSAGE),
  id: yup.string().required(REQUIRED_MESSAGE),
}

export const AutocompleteValueSchema = yup.object(AutocompleteValueSchemaObject)

export type TAutocompleteValueSchema = yup.InferType<typeof AutocompleteValueSchema>
